export default (state, { payload }) => ({
    ...state,
    modifierKeys: state.modifierKeys.filter(modifierKey => modifierKey !== payload),
});
